import { DatePicker, DatePickerProps } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

interface CDatePickerProps extends DatePickerProps<moment.Moment> {
  errorMessage?: string;
}

const CDatePicker = ({ errorMessage, ...props }: CDatePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
      <DatePicker
        format="MM/DD/YYYY"
        reduceAnimations={true}
        slotProps={{
          textField: {
            placeholder: "MM/DD/YYYY",
            fullWidth: true,
            InputLabelProps: {
              shrink: true,
              sx: {
                color: "gray",
                textAlign: "left",
                "&.Mui-focused": {
                  color: "gray",
                },
              },
            },
            sx: {
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#0000003b",
                },
                "&:hover fieldset": {
                  borderColor: "black",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "black",
                  borderWidth: 1,
                },
              },
              ...props.sx,
            },
            error: Boolean(errorMessage),
            helperText: errorMessage,
          },
          actionBar: { actions: ["today", "clear", "accept"] },
        }}
        {...props}
      />
    </LocalizationProvider>
  );
};
export default CDatePicker;
